import { signal } from "@preact/signals-react";
import { TextArea } from "@progress/kendo-react-inputs";

export const LabelProperty = {
  propertyName: "Label",
  propertyDisplay: "Label Text",
  propertyType: "string",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    const value = signal(currentPropertyValues?.[this.propertyName] || "");

    return (
      <TextArea
        name={this.propertyName}
        defaultValue={value}
        onChange={(e) => (value.value = e.target.value)}
        onBlur={() => {
          handlePropertyChange({ propName: this.propertyName, propValue: value.value });
        }}
      />
    );
  },
};
